<template>
  <div>
    <!-- <div style="text-align:end;margin-bottom:16px">
      <el-button class="stockanaly--list__settingbtn" @click="ruleSetting">
        {{ $t('storage::stock-analysis::rule_setting') }}
      </el-button>
    </div> -->
    <div style="display: flex">
      <el-row type="flex" justify="space-between" :gutter="20" style="flex: 1">
        <el-col v-for="(item, index) in cardOptions" :key="index">
          <dataCard :option="item" v-loading="cardLoading" :active="0" @clickPre="cardClick"></dataCard>
        </el-col>
      </el-row>
      <el-card style="margin-left: 20px">
        <div @click="ruleSetting" class="setting">
          <i class="iconfont icona-15shezhi" style="font-size: 24px; color: #999"></i>
          <div style="margin-top: 8px; font-size: 12px; color: #999">{{ $t('system::rbac::设置') }}</div>
        </div>
      </el-card>
    </div>
    <el-card class="stockanaly--list__search">
      <z-search
        :configs="searchConfigData"
        style="margin-bottom: -12px"
        v-model="searchData"
        ref="search"
        @do-query="query"
      ></z-search>
      <z-table
        :columns="tableColumns"
        :data="tableData"
        v-loading="loading"
        :max-height="532"
        row-key="keyId"
        lazy
        :load="loadSku"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @page-change="handlePageChange"
        show-header
        :pagination.sync="pagination"
      >
        <div slot="empty">
          <ZDefaultData :custom="{ height: '490px' }"></ZDefaultData>
        </div>
        <template #stockHeader>
          <span>{{ $t('storage::stock-analysis::stock_in_comming') }}</span>
          <el-tooltip effect="dark" placement="top-start">
            <span slot="content">
              {{ $t('storage::stock-analysis::stock_in_amount') }}
            </span>
            <i class="icon-a-01wenhao iconfont-el" style="font-size: 14px; margin-left: 5px; color: #999"></i>
          </el-tooltip>
        </template>
        <template #stock="{ row }">
          {{ row.advanceStock }}
        </template>
        <template #totalQuantity="{ row }">
          {{ row.totalQuantity }}
        </template>
        <template #day="{ row }">
          {{ row.contentDays }}
        </template>
        <template #dayHeader>
          <span>{{ $t('storage::stock-analysis::full_days') }}</span>
          <el-tooltip effect="dark" placement="top-start">
            <span slot="content">
              {{ $t('storage::stock-analysis::full_days_tips', { day: ruleData.fixPinDays || 0 }) }}
            </span>
            <i class="icon-a-01wenhao iconfont-el" style="font-size: 14px; margin-left: 5px; color: #999"></i>
          </el-tooltip>
        </template>
        <template #prod="{ row }">
          <div class="stockanalysis--table__imgTd">
            <el-popover placement="top-start" trigger="hover" :append-to-body="true">
              <ZImg :src="row.imageUrl" style="width: 250px; height: 250px" />
              <ZImg :src="row.imageUrl" class="images" slot="reference" />
            </el-popover>
            <div>
              <div class="stockanaly--list__name">{{ row.productName }}</div>
              <div v-if="row.isSku" class="stockanaly--list__spu">
                SKU: {{ row.skuId }}{{ row.optionValueNames ? ` | ${row.optionValueNames}` : '' }}
              </div>
              <div v-else class="stockanaly--list__spu">
                SPU: {{ row.spuId }} {{ row.productCategory ? ` | ${row.productCategory}` : '' }}
              </div>
              <el-tag size="small" v-if="row.suggestPurhcase !== ''">
                {{ $t('storage::stock-analysis::purchase_suggest') }}
              </el-tag>
            </div>
          </div>
        </template>
        <template #sale="{ row }">
          <div>{{ $t('storage::stock-analysis::three_day') }}: {{ row.salesThreeDays }}</div>
          <div>{{ $t('storage::stock-analysis::seven_day') }}: {{ row.salesSevenDays }}</div>
          <div>{{ $t('storage::stock-analysis::fifteen_day') }}: {{ row.salesFifteenDays }}</div>
          <el-popover
            placement="left"
            popper-class="popper-class"
            @show="showReport(row)"
            trigger="hover"
            :append-to-body="true"
          >
            <div class="stockanaly--list__trend" slot="reference">
              <img src="../../../assets/images/icon-data.png" />
              {{ $t('storage::stock-analysis::sales_trend') }}
            </div>
            <div style="width: 675px; min-height: 400px">
              <reportCard
                v-loading="popoverLoading"
                :ref="`prod${row.hasChildren ? row.spuId : row.skuId}`"
                :config="configData[`prod${row.hasChildren ? row.spuId : row.skuId}`] || { height: '325px' }"
              ></reportCard>
            </div>
          </el-popover>
        </template>
      </z-table>
    </el-card>
    <rule-setting ref="settingDialog" @success="initData"></rule-setting>
  </div>
</template>

<script>
import dataCard from './components/Card'
import { setCard, searchConfig, tableColumns } from '@/views/stock-control/stock-analysis/config'
import reportCard from '@/components/data-analysis/report'
import RuleSetting from '@/views/stock-control/stock-analysis/components/RuleSetting'
import { getSupplierList } from '@/server/product'
import { getStockRule } from '@/server/stock'
import { getStockData, getStockTableData, getStickLineData, getProdCategories, getSuppliersList } from '@/server/etl'
import monent from 'moment'
import ZImg from '@/components/common/z-img/main'
import ZDefaultData from '@/components/common/default-data/main'

export default {
  name: 'index',
  components: {
    ZImg,
    dataCard,
    reportCard,
    RuleSetting,
    ZDefaultData,
  },
  data() {
    return {
      searchData: {
        searchType: '2',
        // saleDays: '7'
      },
      tableColumns,
      tableData: [],
      cardOptions: setCard(),
      cardLoading: false,
      searchConfigData: searchConfig([], []),
      ruleData: {},
      loading: false,
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0,
      },
      popoverLoading: false,
      merchantId: this.$store.state.user.merchantId,
      configData: {},
      // merchantId: 100
    }
  },
  mounted() {
    this.initSelect()
    this.initData()
  },
  methods: {
    async initSelect() {
      let supplierList = []
      const { data } = await getSuppliersList({ merchantId: this.merchantId })
      if (data.code === 0) {
        supplierList = data.data.datas.map(item => {
          return {
            label: item.supplierName,
            value: item.supplierId,
          }
        })
      }
      const res = await getProdCategories({ merchantId: this.merchantId })
      const cateList = res.data.data.datas.map(item => {
        return {
          label: item.productCategoryName,
          value: item.productCategoryId,
        }
      })
      this.searchConfigData = searchConfig(supplierList, cateList)
    },
    async initData() {
      await this.getRuleData()
      this.getCardData()
      this.getTableData(this.searchData)
    },
    query(data) {
      this.pagination.pageNum = 1
      this.searchData.clickJump = ''
      this.getTableData(data)
    },
    cardClick(data) {
      this.pagination.pageNum = 1
      this.searchData.clickJump = data.type
      this.getTableData(this.searchData)
    },
    async getTableData(filter = {}) {
      const params = {
        ...this.pagination,
        ...this.ruleData,
        ...filter,
        merchantId: this.merchantId,
      }
      if (!params.searchValue) {
        delete params.searchType
      }
      // if (!params.saleDays) {
      //   delete params.saleDays
      // }
      this.loading = true
      params.currentDate = monent().format('YYYY-MM-DD')
      const { data } = await getStockTableData(params)
      if (data.code === this.$code) {
        this.tableData = data.data.datas
        this.pagination.total = data.data.totalSize
        this.tableData.forEach(item => {
          item.hasChildren = true
          item.children = []
        })
      }
      this.loading = false
    },
    handlePageChange() {
      this.$nextTick(() => {
        const params = this.$refs.search.getSearchParams()
        this.getTableData(params)
      })
    },
    async loadSku(tree, treeNode, resolve) {
      const { data } = await getStockTableData({
        spuId: tree.spuId,
        ...this.pagination,
        ...this.ruleData,
        currentDate: monent().format('YYYY-MM-DD'),
        merchantId: this.merchantId,
      })
      if (data.code === this.$code) {
        data.data.datas.forEach(item => {
          item.keyId = item.keyId + new Date()
          item.isSku = true
        })
        resolve(data.data.datas)
      }
    },
    async getRuleData() {
      const { data } = await getStockRule()
      if (data.code === this.$code) {
        this.ruleData = data.data
        this.ruleData.satisfyCycle = this.ruleData.satisfyDays
        this.ruleData.purchaseCycle = this.ruleData.purchaseDays
        this.ruleData.salesUpCycle = this.ruleData.cycleUpDays
        this.ruleData.salesUpRate = this.ruleData.cycleUpPercentage
        this.ruleData.salesDownCycle = this.ruleData.cycleDownDays
        this.ruleData.salesDownRate = this.ruleData.cycleDownPercentage
        this.ruleData.hardSaleCycle = this.ruleData.fixPinDays
      }
    },
    async getCardData() {
      this.ruleData.currentDate = monent().format('YYYY-MM-DD')
      this.cardLoading = true
      const { data } = await getStockData({ ...this.ruleData, merchantId: this.merchantId })
      if (data.code === this.$code) {
        const cardData = {
          ...this.ruleData,
          ...data.data.datas[0],
        }
        this.cardOptions = setCard(cardData)
      }
      this.cardLoading = false
    },
    ruleSetting() {
      this.$refs.settingDialog.show()
    },
    async showReport(report) {
      this.popoverLoading = true
      const { data } = await getStickLineData({
        merchantId: this.merchantId,
        spuId: report.spuId,
        currentDate: monent().format('YYYY-MM-DD'),
      })
      if (data.code === this.$code) {
        const chartData = data.data.datas
        let refName = `prod${report.hasChildren ? report.spuId : report.skuId}`
        this.popoverLoading = false
        console.log(this.$refs[refName])
        // this.$refs[refName].initChart(this.setChartConfig(chartData, refName))
        this.configData[refName] = this.setChartConfig(chartData, refName)
        // this.$refs[refName].config = this.setChartConfig(chartData, refName)
      }
    },
    setChartConfig(data = [], refName) {
      return {
        type: 'line',
        title: '',
        ref: refName || `lineChart`,
        height: '325px',
        chart: {
          grid: {
            top: '13%',
          },
          xAxis: {
            data: data.map(item => item.date),
          },
          legend: {
            show: true,
            data: [this.$t('storage::stock-analysis::final_price'), this.$t('storage::stock-analysis::销量')],
          },
          yAxis: [
            {
              type: 'value',
              name: this.$t('storage::stock-analysis::final_price'),
              splitLine: {
                lineStyle: {
                  color: '#DCDFE6',
                  type: 'dashed',
                },
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#9DA1C3',
              },
            },
            {
              type: 'value',
              min: 0,
              name: this.$t('storage::stock-analysis::销量'),
              axisLabel: {
                formatter: '{value}',
              },
            },
          ],
          series: [
            {
              name: this.$t('storage::stock-analysis::final_price'),
              type: 'line',
              data: data.map(item => item.saleAmount),
            },
            {
              name: this.$t('storage::stock-analysis::销量'),
              type: 'line',
              yAxisIndex: 1,
              data: data.map(item => item.sales),
            },
          ],
        },
      }
    },
  },
}
</script>

<style scoped lang="scss">
.stockanalysis--table__imgTd {
  display: flex;
  align-items: center;
  padding: 5px 0;
  .images {
    width: 50px;
    height: 50px;
    margin-right: 24px;
  }
}
.stockanaly--list {
  &__name {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #010517;
    line-height: 19px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 114px;
    white-space: nowrap;
  }
  &__spu {
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #666666;
    line-height: 16px;
    margin: 6px 0;
  }
  &__search {
    margin-top: 16px;
    ::v-deep {
      .z-search {
        margin: 0;
      }
    }
  }
  &__card {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__trend {
    width: 69px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0560fd;
    line-height: 12px;
    img {
      width: 12px;
      height: 10px;
      margin-right: 2px;
    }
  }
}
.setting {
  height: 76px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
